import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="px-6 md:px-10 lg:px-16 py-16 md:py-24 bg-background-100">
      <div className="mb-12">
        <h2 className="font-heading text-4xl md:text-5xl text-foreground-950 font-thin leading-tight mb-3">
          Shop by Category
        </h2>
        <p className="text-foreground-500 text-sm font-light">
          14 curated categories — fresh spreadsheet finds added daily
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {categories.map((cat, idx) => (
          <article
            key={idx}
            className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
            data-product-shop
          >
            <a href={cat.url} target="_blank" rel="noopener nofollow" className="block cursor-pointer">
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} spreadsheet finds`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  title={`${cat.name} - CSSBuy Spreadsheet Finds`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-5 flex flex-col items-center text-center">
                <h3 className="text-foreground-900 font-semibold text-base mb-1">{cat.name}</h3>
                <p className="text-foreground-400 text-xs mb-4">{cat.count}</p>
                <span className="inline-flex items-center justify-center w-4/5 px-4 py-2 rounded-full border border-foreground-300 text-foreground-700 text-xs font-medium hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-all duration-200 whitespace-nowrap cursor-pointer">
                  Browse Finds
                  <i className="ri-arrow-right-up-line ml-1.5"></i>
                </span>
                <p className="text-foreground-400 text-[10px] mt-3 leading-relaxed max-w-[90%]">{cat.description}</p>
              </div>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}